export default "__VITE_ASSET__cf9bfbb1__"